"use client";

import { useState } from "react";
import { Play } from "lucide-react";
import { Dialog, DialogContent, DialogClose } from "@/components/ui/dialog";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface MediaItem {
  id: number;
  type: "image" | "video";
  src: string;
  alt: string;
}
export default function MediaGallery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const [selectedMedia, setSelectedMedia] = useState<MediaItem | null>(null);
  const mediaItems: MediaItem[] = [{
    id: 1,
    type: "image",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_iglw1ipi.jpg",
    alt: "The Mass theatrical performance moment"
  }, {
    id: 2,
    type: "image",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_8bb48iz9.jpg",
    alt: "Dramatic scene from The Mass production"
  }, {
    id: 3,
    type: "image",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_u4yiqy2v.jpg",
    alt: "The Mass stage performance with cast"
  }, {
    id: 4,
    type: "image",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_2385zwec.jpg",
    alt: "The Mass production lighting and atmosphere"
  }, {
    id: 5,
    type: "image",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_lqkfmble.jpg",
    alt: "Behind the scenes of The Mass by Philip Gray"
  }, {
    id: 6,
    type: "image",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_ckjql5y8.jpg",
    alt: "The Mass production visual moment"
  }];
  return <section id="media-gallery" ref={ref} className="bg-light-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className={`mb-12 text-center transition-all duration-[var(--duration-slow)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
          <h2 className="font-display text-4xl font-bold text-foreground-light sm:text-5xl">
            Media Gallery
          </h2>
          <p className="text-muted-foreground mx-auto mt-4 max-w-2xl text-lg">
            Explore visual highlights of preparations for The Mass, a captivating theatrical experience
          </p>
        </div>

        <div className="columns-1 gap-4 space-y-4 sm:columns-2 lg:columns-3">
          {mediaItems.map((item, i) => <div key={item.id} data-index={i} className={`group relative cursor-pointer overflow-hidden rounded-lg shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} style={{
          transitionDelay: `${i * 50}ms`
        }} onClick={() => setSelectedMedia(item)}>
              {item.type === "image" ? <img src={item.src} alt={item.alt} className="h-auto w-full object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:scale-105" /> : <div className="relative">
                  <video src={item.src} className="h-auto w-full object-cover" muted playsInline />
                  <div className="absolute inset-0 flex items-center justify-center bg-black/40 transition-opacity duration-[var(--duration-medium)] group-hover:bg-black/50">
                    <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary shadow-medium transition-all duration-[var(--duration-medium)] group-hover:scale-110">
                      <Play className="h-8 w-8 fill-foreground text-foreground" />
                    </div>
                  </div>
                </div>}
            </div>)}
        </div>
      </div>

      <Dialog open={!!selectedMedia} onOpenChange={() => setSelectedMedia(null)}>
        <DialogContent className="max-w-4xl bg-dark-background p-0" showCloseButton={true}>
          {selectedMedia?.type === "image" ? <img src={selectedMedia.src} alt={selectedMedia.alt} className="h-auto w-full rounded-lg" /> : selectedMedia?.type === "video" ? <video src={selectedMedia.src} controls autoPlay className="h-auto w-full rounded-lg" /> : null}
        </DialogContent>
      </Dialog>
    </section>;
}